import React from 'react'

import ActionPlanButton from './ActionPlanButton'
import Event from './Event'
import EventsLoader, { useEvents } from './_load/EventsLoader'
import FlexGrid from '../../../../components/structure/FlexGrid'
import Separator from '../../../../components/helpers/Separator'

const EventsList = props => {
  const events = useEvents()

  return (
    <FlexGrid gutter={0.3} direction="column" align="stretch">
      {events.map((item, index) => (
        <Event key={item.id} item={item} startsOpen={item.type === 'instance' && index === 0} {...props} />
      ))}
    </FlexGrid>
  )
}

const Wrapper = ({ nonComplianceIds, hideActionPlanButton, ...props }) => {
  return (
    <EventsLoader nonComplianceIds={nonComplianceIds}>
      <EventsList {...props} />
      <Separator weight={4} />
      {!hideActionPlanButton && <ActionPlanButton />}
    </EventsLoader>
  )
}

export default Wrapper
